import * as mock from "../mocks/simTypes.mock.js";

export function listSimTypes() {
  return mock.listSimTypes();
}

export function createSimType(payload) {
  return mock.createSimType(payload);
}

export function updateSimType(simTypeId, payload) {
  return mock.updateSimType(simTypeId, payload);
}

export function deleteSimType(simTypeId) {
  return mock.deleteSimType(simTypeId);
}

export { SIM_COLUMN_TYPES, SIM_TYPE_STATUSES } from "../mocks/simTypes.mock.js";
